import React, { useState, useEffect, useCallback, useRef } from 'react';
// 아이콘 사용을 위해 react-icons/fa를 사용합니다.
import { FaPencilAlt, FaSearch, FaStar } from 'react-icons/fa';

import {  MdOutlineCameraAlt } from "react-icons/md";

import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css"; 
import { FaHeart,FaCamera } from "react-icons/fa";

import { useSearchParams, useNavigate } from 'react-router-dom';

import InfiniteScroll from 'react-infinite-scroll-component';

import dayjs from 'dayjs';
// dayjs 플러그인 가져오기
import relativeTime from 'dayjs/plugin/relativeTime';
// 한국어 로케일(locale) 가져오기
import 'dayjs/locale/ko'; 

import ImagePopup from '../components/ImagePopup';

import { getrecommendings } from '../network/get_recommendings';
import { getrecommedailylook } from '../network/get_recommdailylook';
import { getpickMoodPosts } from '../network/get_pickMoodPost';
import { getwishes } from '../network/get_wishes';

import { deleteUnfav } from '../network/delete_unfav';
import { deleteUnwishe } from '../network/delete_unwiche';




// 플러그인 사용 설정
dayjs.extend(relativeTime); 
// 언어를 한국어(ko)로 설정
dayjs.locale('ko'); 


// 탭 항목 정의
const TABS = [
  { key: 'rating', label: '평가' },
  { key: 'recommend', label: '추천' },
  { key: 'favorite', label: '찜' },
    { key: 'vote', label: '투표' },
];


  const handleItemClick = (url ,name) => {
        if (url) {
            window.open(url, '_blank');
        } else {
            const googleSearchBaseUrl = 'https://www.google.com/search?q=';
      
      // 2. 검색어(name)를 URL에 안전하게 인코딩
      // 한글이나 특수문자가 포함된 경우를 대비해 인코딩이 필수입니다.
      const encodedName = encodeURIComponent(name);
      
      // 3. 최종 검색 URL 생성
      const finalSearchUrl = googleSearchBaseUrl + encodedName;
      
      // 4. 새 탭에서 Google 검색 결과 페이지 열기
      window.open(finalSearchUrl, '_blank');
        }
    };



const Favorite_page = () => {
  const BASE_URL = 'http://52.79.160.172:8001';
  const PAGE_SIZE = 10; // 한 번에 가져올 항목 수
        const [finalSearchTerm, setFinalSearchTerm] = useState(''); 
   const imageRef = useRef(null);
     const [pageKey, setPageKey] = useState(0);
       const [hasMore, setHasMore] = useState(true);
   const pageKeyRef = useRef(pageKey);
     const [activeTab, setActiveTab] = useState('favorite');
  const [dailylook, setDailylook] = useState(null)
     const [imageSize, setImageSize] = useState({ width: 0, height: 0 });

     const [showEquipments, setShowEquipments] = useState(true);
         const [isPopupOpen, setIsPopupOpen] = useState(false);
         const [isLoading, setIsLoading] = useState(false);

         const [recomData, setRecomData] = useState({ dailylooks: [], brands: [], malls: [] });

               const [genderTerm, setGenderTerm] = useState('');
                     const [bodyTerm, setBodyTerm] = useState('');
                           const [isModalOpen, setIsModalOpen] = useState(false);
                               const [minHeightState, setMinHeightState] = useState(160); // 초기 최소 키
                               const [maxHeightState, setMaxHeightState] = useState(180); // 초기 최대 키
                                         const [isMoodModalOpen, setIsMoodModalOpen] = useState(false);
           const [finalSelection, setFinalSelection] = useState([]);

              const [posts, setPosts] = useState([]);
     
                                         const stars = [1, 2, 3, 4, 5];

                  const [wishData, setWishData] = useState({ brands: [], malls: [] });

const [showConfirmModal, setShowConfirmModal] = useState(false);
  // ⭐️ 삭제 대기 중인 아이템 ID 저장
  const [pendingDeleteId, setPendingDeleteId] = useState(null);

                  async function delWish(id){
                    console.log(id)
                    await deleteUnwishe(id)
                    await deleteUnfav(id)
                    await processData()
                    setShowConfirmModal(false);
    setPendingDeleteId(null);
                  }

                  const handleHeartClick = (_id) => {
    setPendingDeleteId(_id);      // 삭제할 ID 저장
    setShowConfirmModal(true);    // 팝업 표시
  };


function WishItem({_id, name, hashtag, isApplied, onHeartClick, url }) {
    return (
        <div style={styles.listItem}>
            <div style={styles.itemInfo}>
                <span style={styles.itemName} onClick={()=> handleItemClick(url,name)}>{name}</span>
                <span style={styles.itemHashtag}>#{hashtag}</span>
            </div>
            {/* ⭐️ 찜 아이콘 (FaHeart는 꽉 찬 하트, FaRegHeart는 빈 하트) */}
            <FaHeart 
                size={22} 
                color={isApplied ? '#ff4d4f' : '#b0b0b0'} 
                //style={styles.heartIcon}
              onClick={() => onHeartClick(_id)}
            />
        </div>
    );
}





useEffect(() => {
    // ⭐️ pageKey 상태가 변경될 때마다 Ref를 업데이트
    pageKeyRef.current = pageKey; 
}, [pageKey]); // 👈 pageKey가 바뀔 때마다 실행되어야 함

const fetchPosts = useCallback(async () => {


    // 주의: 함수 내부에서 최신 posts.length를 사용하지 않으므로 posts는 의존성에서 제외
     const currentPageKey = pageKeyRef.current; 
       console.log(currentPageKey)
if (isLoading || !hasMore) {
        console.log(`로딩 중단: isLoading=${isLoading}, hasMore=${hasMore}`);
        return; // 호출 중단
    }

    setIsLoading(true);

    
    try {
      const response = await getpickMoodPosts(
        BASE_URL,
        currentPageKey, // 최신 pageKey 사용
        PAGE_SIZE,
        finalSearchTerm,
        finalSelection,
        {
          gender : genderTerm,
          bodyType :bodyTerm,
          minHeight: minHeightState,
          maxHeight: maxHeightState
        }
      );
      console.log(response)
      
      const newPosts = response.results || [];
      const totalCount = response.count;

      // 이전 상태를 기반으로 업데이트해야 정확함
      setPosts(prevPosts => {
          const updatedPosts = [...prevPosts, ...newPosts];
          
          // *주의: posts.length 대신 updatedPosts.length를 사용해야 정확함*
          if (updatedPosts.length >= totalCount) {
              setHasMore(false);
          }
          return updatedPosts;
      });

      console.log(newPosts.length > 0 && 
                   (pageKeyRef.current + newPosts.length < totalCount))

      console.log(newPosts.length > 0)
      console.log(pageKeyRef.current)
      console.log(newPosts.length)
      console.log(totalCount)

      setHasMore(newPosts.length > 0 && 
                   (pageKeyRef.current + newPosts.length < totalCount));

        // API가 0개 항목을 반환했으면 즉시 hasMore를 false로 설정
        if (newPosts.length === 0) {
             setHasMore(false);
        }
      
      setPageKey(currentPageKey + PAGE_SIZE); // 함수형 업데이트를 사용하여 최신 pageKey 보장
      
    } catch (error) {
      console.error("데이터 로딩 실패:", error);
      setHasMore(false);
    } finally {
      setIsLoading(false);
    }
}, [finalSearchTerm, genderTerm, finalSelection,bodyTerm,minHeightState, maxHeightState]);


useEffect(() => {
    // 1. 상태 초기화
    setPosts([]);
    setPageKey(0); 
    setHasMore(true);

    // 2. 초기 로드 조건 (pageKey가 0인 상태에서 데이터 로드 시작)
    const isFilterApplied = finalSearchTerm.trim() !== '' 
        || genderTerm !== 'ALL'
        || finalSelection.length > 0;

    // ⭐️ if (isFilterApplied) { fetchPosts(); } 
    //    이 로직 대신, 로딩이 완료되면 fetchPosts가 실행되도록 다음 useEffect를 사용합니다.
    
    // (이 useEffect는 초기화만 담당하도록 놔두고, 다음 useEffect를 사용합니다.)

}, [finalSearchTerm, genderTerm,bodyTerm, minHeightState, maxHeightState, finalSelection]);


// ⭐️ 새로운 useEffect를 추가하여 pageKey가 0으로 리셋된 후에만 첫 로드를 요청
useEffect(() => {
    // pageKey가 0이고, 필터가 적용되었으며, 아직 로딩 중이 아닐 때만 실행
    const isFilterApplied = finalSearchTerm.trim() !== '' 
        || genderTerm !== 'ALL'
        || finalSelection.length > 0;
        
    // pageKey가 0으로 리셋되었고, 필터가 적용된 상태라면 fetchPosts(0)를 호출
    if (pageKey === 0 && isFilterApplied && !isLoading) {
        fetchPosts(); // fetchPosts가 내부적으로 pageKeyRef.current를 0으로 사용
    }
    
    // 이 useEffect는 pageKey와 필터 상태가 변경될 때마다 실행되도록 합니다.
}, [pageKey, finalSearchTerm, genderTerm, finalSelection, fetchPosts, isLoading]);







     const handleClosePopup = () => {
        setIsPopupOpen(false);
    };



           const navigate = useNavigate();

           const [searchTerm, setSearchTerm] = useState('');
             // 3. 검색 버튼 클릭 또는 Enter 키 입력 시 실행되는 함수
             const handleSearch = () => {
               if (searchTerm.trim() === '') {
                 alert('검색어를 입력해 주세요.');
                 return;
               }
               // 여기에 실제 검색 API 호출 로직을 넣거나 상위 컴포넌트로 전달합니다.
               //postDailylookComment(searchTerm,postId)
               console.log(`검색 실행: ${searchTerm}`);
             };
           
             // 4. Enter 키를 눌렀을 때 검색 함수를 실행하는 핸들러
             const handleKeyDown = (e) => {
               if (e.key === 'Enter') {
                 handleSearch();
               }
             };
             const handleChange = (e) => {
               setSearchTerm(e.target.value);
             };


async function processData() {
  console.log("asda")
        try {
            const wishes = await getwishes();
            setWishData({
            brands: wishes.brands || [],
            malls: wishes.malls || []
        });


            
        } catch (error) {
            console.error("추천 데이터 로드 실패:", error);
            setIsLoading(false);
        }
    }



const handleNavigation = (tabKey) => {
    // ⭐️ 1. TABS의 key를 기반으로 경로를 설정합니다.
    const path = `/${tabKey}`;

    // 2. '/profile' 등의 특별 경로 처리 (이전 로직 유지)
    if (path === '/profile') {
        const savedToken = localStorage.getItem('user');
        const storedUserObject = JSON.parse(savedToken);
        
        // 토큰 체크 로직 강화 (null 또는 파싱 실패 대비)
        if (!storedUserObject || storedUserObject.username === 'temp') {
            navigate('/login');
        } else {
            // 실제 프로필 페이지로 이동 (예시: 사용자 ID와 함께)
            navigate(`/profile?id=${storedUserObject.username}`); 
        }
    } else {
        // 3. 일반적인 탭 경로 이동
        navigate(path);
    }
    console.log(`페이지 이동 요청: ${path}`);
};




    useEffect(() => {

      
      processData()
  
    }, []);



if (!wishData) {
    // API 호출이 완료되었는데 데이터가 없는 경우를 고려하여 로딩 UI 표시
    return <div style={styles.loadingContainer}>찜 목록을 불러오는 중...</div>;
}
    



  return (
    // 메인 컨테이너: 상단 고정 및 양 끝 정렬

 <div>
          <ImagePopup 
                      isOpen={isPopupOpen} 
                      onClose={handleClosePopup} 
                  />

    {!isLoading && (
    <header style={styles.header}>

      <div style={{display : 'flex', justifyContent:'space-between'}}>
      
      {/* 1. 왼쪽 탭 그룹 (Flex) */}
      <div style={styles.tabGroup}>
        {TABS.map((tab) => {
          const isActive = activeTab === tab.key;
          
          return (
            <div 
          key={tab.key} 
          // ⭐️ onClick 이벤트 핸들러 수정: tab.key를 인자로 전달
          onClick={() => handleNavigation(tab.key)} 
          style={styles.tabItem}
        >
              {/* 탭 텍스트 */}
              <span style={{ 
                ...styles.tabText,
                color: isActive ? styles.colors.activeText : styles.colors.inactiveText,
                fontWeight: isActive ? 'bold' : 'normal'
              }}>
                {tab.label}
              </span>
              
              {/* 활성 탭 밑줄 */}
              <div style={{
                ...styles.tabUnderline,
                // 활성 탭에만 검은색 선을 표시하고, 나머지는 투명하게 숨김
                backgroundColor: isActive ? styles.colors.activeUnderline : 'transparent'
              }} />
            </div>
          );
        })}
      </div>
      
      {/* 2. 오른쪽 아이콘 그룹 (Flex) */}
      <div style={styles.iconGroup}>
        {/* 연필 아이콘 */}
        {/* <FaPencilAlt 
          size={22} 
          color={styles.colors.icon} 
          onClick={() => setIsPopupOpen(true)}
          style={{marginLeft: '15px', // 아이콘 간의 간격
        cursor: 'pointer', marginRight : '10pt'}}
        /> */}
        
        {/* 돋보기 아이콘 */}
        <MdOutlineCameraAlt 
          size={22} 
          color={styles.colors.icon} 
          onClick={() => setIsPopupOpen(true)}
          style={styles.iconStyle}
        />
      </div>
      </div>
    </header>

    

    

    
    )}

    <main style={styles.mainContent}>
            
            {/* 1. 브랜드 섹션 */}
            <div style={styles.wishSection}>
                <h2 style={styles.wishTitle}>브랜드</h2>
                
                {wishData.brands.length > 0 ? (
                    // ⭐️ 브랜드 목록 렌더링
                    <div style={styles.listWrapper}>
                        {wishData.brands.map((brand) => (
                            <WishItem 
                                _id={brand.equipment_id} 
                                name={brand.name} 
                                hashtag={brand.hashtag} 
                                isApplied={true} // 찜 목록이므로 기본값 true 가정
                                onHeartClick={handleHeartClick}
                                url={brand.url}
                            />
                        ))}
                    </div>
                ) : (
                    <p style={styles.noDataText}>찜한 브랜드가 없습니다.</p>
                )}
            </div>

           {/* <div style={styles.sectionDivider}></div>*/}

            {/* 2. 쇼핑몰 섹션 */}
            <div style={styles.wishSection}>
                <h2 style={styles.wishTitle}>쇼핑몰</h2>
                
                {wishData.malls.length > 0 ? (
                    // ⭐️ 쇼핑몰 목록 렌더링
                    <div style={styles.listWrapper}>
                        {wishData.malls.map((mall) => (
                            <WishItem 
                                _id={mall.equipment_id} 
                                name={mall.name} 
                                hashtag={mall.hashtag} 
                                isApplied={true} // 찜 목록이므로 기본값 true 가정
                                onHeartClick={handleHeartClick}
                                url={mall.url}
                            />
                        ))}
                    </div>
                ) : (
                    <p style={styles.noDataText}>찜한 쇼핑몰이 없습니다.</p>
                )}
            </div>
            
            
        </main>
        {showConfirmModal && pendingDeleteId && (
        <ConfirmationModal
          message="즐겨찾기를 취소하시겠습니까?"
          onConfirm={() => delWish(pendingDeleteId)} // 저장된 ID로 삭제 실행
          onCancel={() => setShowConfirmModal(false)} // 팝업 닫기
        />
      )}
    


</div>



  );
};

function ConfirmationModal({ message, onConfirm, onCancel }) {
    return (
        // ⭐️ 배경 (backdrop)
        <div style={modalStyles.backdrop}>
            {/* ⭐️ 모달 내용 컨테이너 */}
            <div style={modalStyles.content}>
                {/* 메시지 */}
                <p style={modalStyles.message}>{message}</p>
                
                {/* 버튼 그룹 */}
                <div style={modalStyles.buttonGroup}>
                    
                    {/* 아니오 버튼 (좌측, 흰색 배경) */}
                    <button 
                        onClick={onCancel} 
                        style={{
                              width: "100%",
                              border: "none",
                              height: "35px",
                              borderRadius: "10px",
                              background: "#aeaeae",
                              color: "white",
                              
                          }}
                    >
                        아니오
                    </button>
                    
                    {/* 확인 버튼 (우측, 빨간색 배경) */}
                    <button 
                        onClick={onConfirm} 
                        style={{
                              width: "100%",
                              border: "none",
                              height: "35px",
                              borderRadius: "10px",
                              background: "#F56060",
                              color: "white",
                          }}
                    >
                        확인
                    </button>
                </div>
            </div>
        </div>
    );
}

// ----------------------------------------------------
// 스타일 정의
// ----------------------------------------------------
const styles = {

  mainContent: {
        // 고정 Header 높이만큼 paddingTop을 확실히 적용
        paddingTop: '50px', // Header 높이 50px 가정
        padding: '50px 3vw 20px 3vw', // 상단 패딩을 명시적으로 설정
    },
    
    wishSection: {
        marginBottom: '20px',
    },
    wishTitle: {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#ff4d4f', // 이미지의 빨간색
        margin: '0 0 15px 0',
    },
    listWrapper: {
        // 목록 전체를 감싸는 Wrapper (스크롤 가능한 경우 overflow-y: auto)
        // 현재는 전체 페이지가 스크롤되므로 별도의 스크롤 속성은 제외
    },
    listItem: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '15px 0',
        borderBottom: '1px solid #f0f0f0', // 항목 간 구분선
    },
    itemInfo: {
        display: 'flex',
        flexDirection: 'column',
    },
    itemName: {
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#000',
        marginBottom: '2px',
    },
    itemHashtag: {
        fontSize: '13px',
        color: '#888', // 회색 텍스트
    },
    heartIcon: {
        cursor: 'pointer',
    },
    sectionDivider: {
        height: '1px',
        backgroundColor: '#f0f0f0',
        margin: '30px 0',
    },
    noDataText: {
        textAlign: 'center',
        color: '#aaa',
        padding: '20px 0',
    },

  filterSection: {
        // paddingTop은 헤더에 가려지지 않도록 이미 mainContent에서 처리되었으므로 필요 없음.
        padding: '10px 0',
        //marginTop: '130px', // 헤더 영역과 검색창 아래 여백을 위해 임시 설정
    },
    
    // ⭐️ 드롭다운 컨테이너 (가로 스크롤 및 배치)
    dropdownsWrapper: {
        display: 'flex',
        //overflowX: 'scroll', // 가로 스크롤 가능
        paddingBottom: '10px',
        gap: '8px', // 드롭다운 버튼 사이 간격
        // 스크롤바 숨기기 (필요 시)
        // msOverflowStyle: 'none', // IE and Edge
        // scrollbarWidth: 'none', // Firefox
    },
    
    // ⭐️ 드롭다운 버튼 공통 스타일 (이미지처럼 검은 테두리와 흰 배경)
    dropdownButton: {
        // ... (기존 스타일 유지) ...
        
        border: '1px solid #333', // 검은색 테두리
        borderRadius: '8px',
        padding: '7px 7px',
        fontSize: '14px',
        whiteSpace: 'nowrap', // 버튼 내용 줄바꿈 방지
    },
    
    // ⭐️ 키 설정 버튼 스타일 (Dropdown과 동일하게 보이도록 복사)
    heightButton: {
        border: '1px solid #333',
        borderRadius: '8px',
        backgroundColor: '#fff',
        color: '#333',
        padding: '7px 7px',
        fontSize: '14px',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
    },
    // ⭐️ 무드 설정 버튼 스타일 (Dropdown과 동일하게 보이도록 복사)
    moodButton: {
        border: '1px solid #333',
        borderRadius: '8px',
        backgroundColor: '#fff',
        color: '#333',
        padding: '7px 7px',
        fontSize: '14px',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
    },

    // ----------------- 선택된 태그 스타일 -----------------
    selectedTagsWrapper: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '8px',
        marginTop: '10px',
    },
    selectedTag: {
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '#fff0f0', // 이미지의 연한 핑크 배경
        color: '#333',
        padding: '6px 10px',
        borderRadius: '15px', // 둥근 모서리
        fontSize: '14px',
        fontWeight: 'bold',
        whiteSpace: 'nowrap',
    },
    removeTagButton: {
        marginLeft: '6px',
        backgroundColor: 'transparent',
        border: 'none',
        color: '#333',
        fontWeight: 'bold',
        fontSize: '12px',
        cursor: 'pointer',
        padding: 0,
        lineHeight: 1,
    },

mainContent: {
        paddingTop: '60px', // Header 높이 + 여백
        padding: '60px 15px 20px 15px', // 상단 패딩을 확실히 줍니다.
    },
    
    // ----------------- 추천 섹션 공통 스타일 -----------------
    section: {
        marginBottom: '30px',
    },
    sectionTitle: {
        fontSize: '20px',
        fontWeight: 'bold',
        margin: '0 0 5px 0',
    },
    sectionSubtitle: {
        fontSize: '14px',
        color: '#ff4d4f', // 이미지의 붉은색
        margin: '0 0 15px 0',
    },
    sectionDivider: {
        height: '1px',
        backgroundColor: '#f0f0f0',
        margin: '30px 0',
    },
    
    // ----------------- 데일리룩 그리드 스타일 -----------------
    dailylookGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)', // 3열 배치
        gap: '8px', // 이미지 간 간격
        width: '100%',
    },
    dailylookImageItem: {
        width: '100%',
        height: '130px', // 고정 높이 또는 비율을 위해 padding-bottom 사용 가능 (여기서는 고정)
        objectFit: 'cover', // 이미지가 잘리지 않게 영역을 채움
        borderRadius: '5px',
        cursor: 'pointer',
    },

    // ----------------- 목록 아이템 스타일 -----------------
    listItem: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '10px 0',
        borderBottom: '1px solid #f9f9f9', // 아이템 간 얇은 구분선
    },
    itemName: {
        fontSize: '16px',
        fontWeight: '500',
        color: '#333',
    },
    heartIcon: {
        color: '#b0b0b0', // 회색 하트
    },


darkOverlay: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%',
        height: '30%', // 이미지 높이의 약 30%를 검은색으로 덮음
        backgroundImage:'linear-gradient(0deg, black, transparent)',
        opacity: 0.9, // 약간의 투명도를 주어 자연스럽게 보이게 함
        zIndex: 1, // 별 아이콘보다 아래에 있어야 함
    },
    // 4. 별점 아이콘 그룹 스타일
    starGroup: {
        position: 'absolute',
        bottom: '10px', // 하단으로부터의 간격 조정
        left: '50%',
        transform: 'translateX(-50%)', // 중앙 정렬
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '10px', // 별 사이 간격
        width: '90%', // 별 그룹의 너비
        zIndex: 2, // 검은색 오버레이 위에 표시
    },
    starIcon: {
      width :'70',
      height :'70'
        // 추가 스타일이 필요하다면 여기에 정의
    },

    colors: {
        background: '#ffffff',
        border: '#d4d4d4ff',
        activeText: '#000000',
        inactiveText: '#a0a0a0', // 사진 속 회색 텍스트
        activeUnderline: '#000000',
        icon: '#000000'
    },
    header: {
        // 상단 고정 설정
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        
        // 레이아웃 설정
        display: 'flex',
        justifyContent: 'space-between', // 왼쪽 탭 그룹과 오른쪽 아이콘 그룹 분리
        alignItems: 'center',
        
        // 크기 및 외관
        height: '50px',
        backgroundColor: '#ffffff',
        borderBottom: `1px solid ${'#d4d4d4ff'}`, // 하단 구분선
        padding: '0 15px', // 좌우 패딩
        maxWidth: '420px', // 모바일 최대 너비
        margin: '0 auto', // 중앙 정렬
        zIndex: 10, // 다른 콘텐츠 위에 표시
    },
    tabGroup: {
        display: 'flex',
        alignItems: 'center',
        marginLeft:'15px'
        // 탭 사이의 공간을 줄여 사진과 유사하게 만듭니다.
    },
    tabItem: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '0 10px', // 탭 간의 가로 간격
        cursor: 'pointer',
        height: '100%',
        justifyContent: 'flex-end', // 밑줄을 바닥에 맞춥니다.
        // 탭 텍스트에만 상단 패딩을 줄 수도 있습니다.
    },
    tabText: {
        fontSize: '16px',
        paddingBottom: '8px', // 텍스트와 밑줄 사이의 간격
        whiteSpace: 'nowrap', // 텍스트 줄바꿈 방지
    },
    tabUnderline: {
        width: '100%',
        height: '2px', // 밑줄 두께
        // 활성 상태에 따라 색상이 결정됩니다.
    },
    iconGroup: {
        display: 'flex',
        alignItems: 'center',
        marginRight:'15px'
    },
    
buttonBase: {
        backgroundColor: '#000000ff',
        color: 'white',
        border: 'none',
        borderRadius: '8px',
        padding: '6px 15px',
        cursor: 'pointer',
        fontSize: '10px',
    },

  value: {
    fontSize: '24px',
    fontWeight: 'bold',
    margin: 0,
  },

container: {
        width: '100%',
        maxWidth: '400px', // 모바일 환경에 맞게 최대 너비 설정
        margin: '20px auto',
    },
    // 사진 속 둥근 박스 스타일
    itemBox: {
        display: 'flex',
        justifyContent: 'space-between', // 양 끝 정렬 (파트와 브랜드)
        alignItems: 'center',
        padding: '15px 20px',
        margin: '10px 0',
        backgroundColor: '#ffffff',
        borderRadius: '15px', // 둥근 모서리
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)', // 약간의 그림자
        cursor: 'pointer', // 클릭 가능함을 표시
    },
    // 왼쪽 텍스트 그룹 (PART + 브랜드)
    leftGroup: {
        display: 'flex',
        alignItems: 'center',
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#000000',
    },
    // 오른쪽 브랜드/쇼핑몰 이름
    rightName: {
        fontSize: '16px',
        color: '#000000',
    },
    // '브랜드' 텍스트의 붉은색 스타일
    redText: {
        color: '#ff4d4f', // 빨간색 계열
        marginLeft: '5px',
        fontWeight: 'normal',
        fontSize: '14px',
    },


  feedContainer: {
        maxWidth: '420px',
        margin: '0 auto',
        padding: '10px 15px',
    },
    controlPanel: {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        marginBottom: '20px',
    },
    keywordInput: {
        padding: '10px',
        borderRadius: '5px',
        border: '1px solid #ddd',
    },
    filterButton: {
        padding: '10px',
        borderRadius: '5px',
        border: '1px solid #007bff',
        backgroundColor: '#fff',
        color: '#007bff',
        cursor: 'pointer',
    },
    resultTitle: {
        fontSize: '16px',
        fontWeight: 'bold',
        marginBottom: '15px',
    },
    postsGrid: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr', 
        gap: '1px',
    },
    postItem: {
        border: '1px solid #eee',
        borderRadius: '8px',
        overflow: 'hidden',
    },
    postImage: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    },
  mobileContainer: {
    maxWidth: '420px', // 일반적인 모바일 최대 너비
    margin: '0 auto',  // 중앙 정렬 (웹에서 볼 경우 대비)
    // padding: '0 5vw', // 좌우 패딩을 뷰포트 너비 기준으로 설정하여 반응성 확보
  },
  
  header: {
    paddingTop: '20px',
    position:'fixed',
    top:'0',
    width:'100%',
    maxWidth:'420px',
    backgroundColor:'white',
    zIndex:'1'
  },
  
  headerContent: {
    display: 'flex',
    justifyContent: 'space-between', // 요소들을 양 끝으로 분산
    alignItems: 'center',
  },
  
  logo: {
    width: '100px',
    // 로고는 중앙에 위치하도록 flexbox가 처리
  },
  
  iconWrapper: {
    // 아이콘 그룹을 위한 컨테이너 (각 아이콘에 개별 마진 대신 flex 사용)
    width: '30px', 
  },
  
  iconStyle: {
    // 아이콘 크기는 이미 24px로 설정됨
  },
  
  divider: {
    height: '1px', 
    backgroundColor: '#d4d4d4ff', 
    marginTop: '20px', // 수직 여백을 뷰포트 높이 기준으로 설정
  },

  infoSection: {
    display: 'flex',
    justifyContent: 'space-between', // 주간모디 그룹과 임시 박스를 양 끝으로 분산
    alignItems: 'center',
    marginBottom: '5px',

  },
  
  titleGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: '5px', // 요소 사이의 간격
  },
  
  titleText: {
    color: '#000000ff',
    fontSize: '1.2rem',
    fontWeight: 'bold',
  },
  
  infoIcon: {
    color: '#000000ff',
    cursor: 'pointer',
  },

  placeholderBox: {
    width: '70px',
    height: '20px',
    backgroundColor: 'rgb(0, 0, 0)',
    // flexbox가 자동으로 오른쪽 끝에 배치
  },
  
  bestTitle: {
    color: '#ff0000ff',
    fontSize: 'small',

    margin: '5px 0',
  },

  dailylooksGrid: {
    display: 'flex',
    justifyContent: 'space-between', // 두 이미지를 양 끝으로 분산
    gap: '10px', // 이미지 사이 간격
    marginTop: '10px',
  },

  dailylookImage: {
    width: '47%', // 컨테이너 너비의 49%를 차지 (간격 포함 100% 미만)
    //height: '59vw',
        borderRadius: '8px',
    objectFit: 'cover',

  },

  sliderContainer: {
      // 슬라이더 자체의 좌우 패딩을 모바일 컨테이너와 동일하게 맞추려면 padding: 0 이 필요할 수 있음
      // 여기서는 모바일 컨테이너의 패딩을 따름
      marginBottom: '20px',
      position:'relative'
      // slick-dots 커스터마이징을 위해 추가 CSS 필요
  },
  bannerLink: {
      display: 'block',
  },
  bannerImage: {
      width: '100%',
      // height: '500px',
      borderRadius: '10px', // 이미지와 같은 모서리 둥글게 처리
      display: 'block', // 인라인 요소의 기본 여백 제거
  },

  defaultTag: {
    // 배경 및 텍스트 색상
    backgroundColor: '#333333', 
    color: '#ffffff',
    
    // 모서리 둥글게
    borderRadius: '10px', 
    
    // 내부 여백 (클릭 영역 확보)
    padding: '8px 15px', 
    
    // 글꼴 설정 (폰트에 따라 다를 수 있음)
    fontSize: '14px', 
    fontWeight: 'normal',
    
    // 기타 설정
    border: 'none',
    cursor: 'pointer',
    outline: 'none',
    
    // 옆 요소와의 간격
    marginRight: '10px', 
  },
  
  // 텍스트 밑줄 스타일 (이미지와 가장 유사하게 구현하기 위해 span에 적용)
  textUnderline: {
    // 텍스트와 거의 같은 색상의 얇은 밑줄 효과
    borderBottom: '1px solid #ffffff', 
    paddingBottom: '2px', // 텍스트와 밑줄 사이의 간격
  },
  
  // 선택되었을 때의 스타일 (필요하다면)
  // activeTag: {
  //   // defaultTag 스타일을 복사하고 필요한 부분만 변경 (예: 빨간색 테두리)
  //   ...this.defaultTag,
  //   // 예시: 선택 시 배경색 변경
  //   backgroundColor: '#111111', 
  // }
  searchContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    maxWidth: '400px', // 컴포넌트의 최대 너비를 제한하여 모바일에 적합하게 조정
    margin: '20px auto',
    border: '1px solid #ccc',
    borderRadius: '25px', // 둥근 모서리
    overflow: 'hidden', // 버튼과 인풋필드를 묶음
    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
  },
  inputField: {
    flexGrow: 1, // 입력 필드가 남은 공간을 모두 차지하도록
    padding: '10px 15px',
    border: 'none',
    outline: 'none',
    fontSize: '16px',
    lineHeight: 1.5,
  },
  searchButton: {
    backgroundColor: 'transparent',
    border: 'none',
    padding: '10px 15px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background-color 0.2s',
  },

  dropdownContainer: {
    position: 'relative',
    display: 'inline-block', // 너비를 내용물에 맞춥니다.
  },
  dropdownButton: {
    padding: '10px 20px',
    border: '1px solid #ccc',
    borderRadius: '5px',
    backgroundColor: '#fff',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',

  },
  arrow: {
    marginLeft: '10px',
    fontSize: '10px',
  },
  dropdownMenu: {
    position: 'absolute',
    top: '100%', // 버튼 바로 아래에 배치
    left: 0,
    zIndex: 1000,
    minWidth: '100%',
    padding: 0,
    margin: '4px 0 0 0',
    border: '1px solid #ccc',
    borderRadius: '5px',
    backgroundColor: '#fff',
    listStyle: 'none', // 리스트 마커 제거
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
  },
  menuItem: {
    padding: '10px 20px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#f0f0f0', // 마우스 오버 시 배경색 변경 (인라인 스타일에서는 직접 구현 어려움)
    },
  },

    modalHeader: {
    fontSize: '18px',
    fontWeight: 'bold',
    marginBottom: '5px',
    textAlign: 'center',
  },
  modalSubtitle: {
    fontSize: '14px',
    color: '#666',
    marginBottom: '20px',
    textAlign: 'center',
  },
  tagsGrid: {
    display: 'flex',
    flexWrap: 'wrap', // 태그를 다음 줄로 넘김
    gap: '8px',       // 태그 간의 간격
    maxHeight: '400px', // 스크롤이 필요할 경우 최대 높이 지정
    overflowY: 'auto',
    padding: '10px 0',
  },
  tagBase: {
    padding: '8px 15px',
    borderRadius: '20px', // 타원형 모양을 위한 큰 BorderRadius
    border: '1px solid transparent',
    fontSize: '14px',
    cursor: 'pointer',
    transition: 'background-color 0.2s, color 0.2s',
  },
  tagDefault: {
    backgroundColor: '#f0f0f0', // 비활성화된 태그 배경색 (연한 분홍색과 유사하게)
    color: '#333',
  },
  tagSelected: {
    backgroundColor: '#e64e4e', // 선택된 태그 배경색 (이미지의 빨간색)
    color: 'white',
    fontWeight: 'bold',
  },
  confirmButton: {
    width: '100%',
    padding: '15px 0',
    marginTop: '20px',
    backgroundColor: '#e64e4e', // 이미지와 같은 빨간색
    color: 'white',
    border: 'none',
    borderRadius: '10px',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
  }
  


}
const dropdownStyles = {
  container: {
    marginBottom: '15px',
  },
  label: {
    display: 'block',
    marginBottom: '5px',
    fontWeight: 'bold',
    fontSize: '14px',
    color: '#555',
  },
  select: {
    width: '100%',
    padding: '10px',
    borderRadius: '5px',
    border: '1px solid #ccc',
    fontSize: '16px',
    appearance: 'none', // 브라우저 기본 드롭다운 스타일 제거
  }
};

const modalStyles = {
  backdrop: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  content: {
    backgroundColor: 'white',
    padding: '30px',
    borderRadius: '8px',
    width: '90%',
    maxWidth: '350px',
    boxShadow: '0 5px 15px rgba(0, 0, 0, 0.3)',
  },
  buttonGroup: {
    marginTop: '20px',
    display: 'flex',
    justifyContent: 'space-between',
    gap: '10px',
  },
  closeButton: {
    padding: '10px 15px',
    border: '1px solid #ccc',
    borderRadius: '5px',
    backgroundColor: '#eee',
    cursor: 'pointer',
  },
  saveButton: {
    padding: '10px 15px',
    border: 'none',
    borderRadius: '5px',
    backgroundColor: '#007bff',
    color: 'white',
    cursor: 'pointer',
  },
};

const mainStyles = {
    openButton: {
        padding: '10px 20px',
        border: 'none',
        borderRadius: '5px',
        backgroundColor: '#f0f0f0',
        cursor: 'pointer',
        fontWeight: 'bold',
        fontSize: '16px',
    }
}

export default Favorite_page;